import { findIndex, slice, uniqBy, forEach, remove, find, map } from "lodash"

function sortTrueLastFalse(a, b) {
  return !!a.disabled - !!b.disabled
}

function orderItems(a, b) {
  const aVal = Number(a.finish)
  const bVal = Number(b.finish)

  if (aVal < bVal) {
    return -1
  }
  if (aVal > bVal) {
    return 1
  }

  return 0
}

export default ({ arrayObjects, boxSelected, finishValue }) => {
  const indexElement = findIndex(
    arrayObjects,
    (item) => item.id === boxSelected.id
  )
  let initElement = indexElement + 1
  let thereIs100 = false

  if (Number(boxSelected.start) >= finishValue) return arrayObjects

  arrayObjects[indexElement].finish = finishValue
  arrayObjects[indexElement + 1].start = finishValue + 1

  for (let i = indexElement; i < arrayObjects.length; i++) {
    const element = arrayObjects[i + 1]

    if (element) {
      if (finishValue + 1 >= Number(element.finish)) {
        const indexElementY = findIndex(
          arrayObjects,
          (item) => item.id === element.id
        )
        for (let y = indexElementY; y < arrayObjects.length; y++) {
          const elementY = arrayObjects[y]

          if (finishValue + 1 < Number(elementY.finish)) {
            arrayObjects[initElement].finish = elementY.finish
            arrayObjects[initElement + 1].start = Number(elementY.finish) + 1

            initElement++
          } else if (arrayObjects[y].start == 100) {
            arrayObjects[y].finish = 100
          }
        }
      }
    }
  }

  return map(arrayObjects, (item) => {
    if (item.finish == 100 && !thereIs100) {
      thereIs100 = true
      return {
        ...item,
        disabled: false,
      }
    }

    return {
      ...item,
      disabled: !!thereIs100,
    }
  })
}
